import React,{useState, useEffect, useContext} from 'react'
import "./AddPlanModal.css"
import axios from 'axios';

export default function PartApiCall({SelectedPart,filteredData}) {

const[partData, setPartData] = useState([])
    

const handlePartSelection =(e)=>{
   SelectedPart(e.target.value)
}

  const updateData = async () => {
    axios
      .get("http://mm.thirdeye-ai.com/chartserver/queryDB?collection=partList&mode=search")
      .then(function (data) {
        setPartData(data.data);
        return;
      })
      .catch((e) => {
        console.log("you are just stuck in axios request", e);
        return;
      });
  };

  useEffect(() => {
    updateData();
  }, []);

  return (

     <div className="col-md-6">
        <div className="form-group">
            <label>Select Part</label>
            <select name='selectedPart' onChange={handlePartSelection} className="form-control">
            <option value="" >all</option>
               {
                /////IF WE WANT TO SHOW FILTERED DATA
                // filteredData.map((data) => (
                //         <option key={data._id} value={data.partId}>{data.partId}</option>
                //     ))
                    partData.map((data) => (
                      <option key={data._id} value={data.partCode}>{data.partCode}</option>
                  ))
                }  
                 
                
            </select>
        </div>
    </div>
)
}
